import dompurify from 'dompurify';

export const script = dompurify.sanitize(`
(function(w,d,s,l){
    w[l]=w[l]||[];
    w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});
})(window,document,'script','dataLayer');`);
